import actions from "./actions";

const {
  AUTO_BILLING_PARTNER_LIST_BEGIN,
  AUTO_BILLING_PARTNER_LIST_SUCCESS,
  AUTO_BILLING_PARTNER_LIST_ERR,
  AUTO_BILLING_PARTNER_LIST_RESET,
  AUTO_BILLING_REFERENCE_BEGIN,
  AUTO_BILLING_REFERENCE_SUCCESS,
  AUTO_BILLING_REFERENCE_ERR,
  AUTO_BILLING_REFERENCE_RESET,
  AUTO_BILLING_PAYMENT_MODE_BEGIN,
  AUTO_BILLING_PAYMENT_MODE_SUCCESS,
  AUTO_BILLING_PAYMENT_MODE_ERR,
  AUTO_BILLING_PAYMENT_MODE_RESET,
  AUTO_BILLING_SUBMIT_BEGIN,
  AUTO_BILLING_SUBMIT_SUCCESS,
  AUTO_BILLING_SUBMIT_ERR,
  AUTO_BILLING_SUBMIT_RESET,
  AUTO_BILLING_MANUAL_BEGIN,
  AUTO_BILLING_MANUAL_SUCCESS,
  AUTO_BILLING_MANUAL_ERR,
  AUTO_BILLING_MANUAL_RESET,
  AUTO_BILLING_HISTORY_BEGIN,
  AUTO_BILLING_HISTORY_SUCCESS,
  AUTO_BILLING_HISTORY_ERR,
  AUTO_BILLING_HISTORY_RESET,
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const createAutoBillingReducer = (begin, success, failure, reset) => {
  return (state = initialState, action) => {
    const { type, data, err } = action;

    switch (type) {
      case begin:
        return {
          ...initialState,
          loading: true,
        };

      case success:
        return {
          ...initialState,
          data,
          loading: false,
        };

      case failure:
        return {
          ...initialState,
          error: err,
          loading: false,
        };

      case reset:
        return initialState;

      default:
        return state;
    }
  };
};

export const autoBillingPartnerListReducer = createAutoBillingReducer(
  AUTO_BILLING_PARTNER_LIST_BEGIN,
  AUTO_BILLING_PARTNER_LIST_SUCCESS,
  AUTO_BILLING_PARTNER_LIST_ERR,
  AUTO_BILLING_PARTNER_LIST_RESET,
);

export const autoBillingReferenceReducer = createAutoBillingReducer(
  AUTO_BILLING_REFERENCE_BEGIN,
  AUTO_BILLING_REFERENCE_SUCCESS,
  AUTO_BILLING_REFERENCE_ERR,
  AUTO_BILLING_REFERENCE_RESET,
);

export const autoBillingPaymentModeReducer = createAutoBillingReducer(
  AUTO_BILLING_PAYMENT_MODE_BEGIN,
  AUTO_BILLING_PAYMENT_MODE_SUCCESS,
  AUTO_BILLING_PAYMENT_MODE_ERR,
  AUTO_BILLING_PAYMENT_MODE_RESET,
);

export const autoBillingSubmitReducer = createAutoBillingReducer(
  AUTO_BILLING_SUBMIT_BEGIN,
  AUTO_BILLING_SUBMIT_SUCCESS,
  AUTO_BILLING_SUBMIT_ERR,
  AUTO_BILLING_SUBMIT_RESET,
);

export const autoBillingManualReducer = createAutoBillingReducer(
  AUTO_BILLING_MANUAL_BEGIN,
  AUTO_BILLING_MANUAL_SUCCESS,
  AUTO_BILLING_MANUAL_ERR,
  AUTO_BILLING_MANUAL_RESET,
);

export const autoBillingHistoryReducer = createAutoBillingReducer(
  AUTO_BILLING_HISTORY_BEGIN,
  AUTO_BILLING_HISTORY_SUCCESS,
  AUTO_BILLING_HISTORY_ERR,
  AUTO_BILLING_HISTORY_RESET,
);
